import { type FC } from 'react';
import cn from 'classnames';

interface CircleProductionProgressProps {
  className?: string;
  percentage: number;
}

const CircleProductionProgress: FC<CircleProductionProgressProps> = ({
  className,
  percentage,
}) => {
  const deg = (360 * percentage) / 100;

  return (
    <div className={cn('w-3 h-3', className)}>
      <div className="relative w-full h-full rounded-full border border-white/20 bg-transparent z-[1]">
        <div
          style={{
            background: `conic-gradient(#82E024 0deg ${deg}deg, rgba(0,0,0,0) ${deg}deg)`,
          }}
          className="absolute rounded-full top-0 left-0 w-full h-full z-[2]"
        ></div>
      </div>
    </div>
  );
};

export { CircleProductionProgress };
